var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"flex items-center justify-between p-4 desktop:px-6 text-gray-900",class:{
      'bg-errorBg': _vm.type === _vm.AlertType.ERROR,
      'bg-success': _vm.type === _vm.AlertType.SUCCESS,
      'bg-warning': _vm.type === _vm.AlertType.WARNING
    }},[_c('span',{staticClass:"mr-2 leading-tight"},[_vm._v(_vm._s(_vm.msg))]),_c('lm-icon-button',{attrs:{"icon":"close","svg":"","svg-size":"20"},on:{"click":function($event){return _vm.$emit('close')}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }